import qs from 'qs'
import request from '@/utils/request'

// ============================================================
// 政企实训管理端接口封装
// 后端统一约定：POST + 表单参数（@RequestParam），故全部使用 qs.stringify
// 鉴权：除登录外，请求头由 request.js 自动携带 userzqsx（登录返回的 aesUser 凭证）
// 注：zqsx 模块的鉴权头为 userzqsx，区别于其他业务的 useraxj
// ============================================================

// ==================== 认证 ====================

// 管理端登录（手机号 + 密码，返回含 aesUser 凭证的用户信息）
export function doLogin (data) {
  return request({ url: '/zqsx-auth-user/doLogin', method: 'post', data: qs.stringify(data) })
}

// 获取当前用户所属项目记录列表（登录后切换项目用）
export function getZqsxAuthUserProjectList (data) {
  return request({ url: '/zqsx-auth-user/getZqsxAuthUserProjectList', method: 'post', data: qs.stringify(data) })
}

// ==================== 用户管理 ====================

// 用户列表（分页，支持姓名/账号/岗位筛选；项目管理员仅查所属项目用户）
export function getZqsxAuthUserList (data) {
  return request({ url: '/zqsx-auth-user/getZqsxAuthUserList', method: 'post', data: qs.stringify(data) })
}

// 新增用户（zauPw 明文传入，后端加密存储）
export function addZqsxAuthUser (data) {
  return request({ url: '/zqsx-auth-user/addZqsxAuthUser', method: 'post', data: qs.stringify(data) })
}

// 编辑用户（zauPw 为空则不修改密码）
export function updateZqsxAuthUser (data) {
  return request({ url: '/zqsx-auth-user/updateZqsxAuthUser', method: 'post', data: qs.stringify(data) })
}

// 删除用户（逻辑删除）
export function deleteZqsxAuthUser (data) {
  return request({ url: '/zqsx-auth-user/deleteZqsxAuthUser', method: 'post', data: qs.stringify(data) })
}

// 重置用户密码
export function resetZqsxAuthUserPw (data) {
  return request({ url: '/zqsx-auth-user/resetZqsxAuthUserPw', method: 'post', data: qs.stringify(data) })
}

// 导出用户导入模板（返回 Excel 文件流，用于填写后批量导入用户）
export function exportZqsxAuthUserTemplate () {
  return request({
    url: '/zqsx-auth-user/exportZqsxAuthUserTemplate',
    method: 'post',
    responseType: 'blob'
  })
}

// 批量导入用户（file 走 formData；项目管理员导入的用户固定为普通用户岗位3）
// 返回：{ total, successCount, failCount, list:[{rowIndex, zauName, zauPhone, status, statusMsg}] }
export function importZqsxAuthUser (data) {
  const { file } = data
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: '/zqsx-auth-user/importZqsxAuthUser',
    method: 'post',
    data: formData
  })
}

// ==================== 项目管理（增删改仅系统管理员） ====================

// 项目列表（分页，系统管理员查全部，项目管理员仅查所属）
export function getZqsxAuthProjectList (data) {
  return request({ url: '/zqsx-auth-project/getZqsxAuthProjectList', method: 'post', data: qs.stringify(data) })
}

// 新增项目
export function addZqsxAuthProject (data) {
  return request({ url: '/zqsx-auth-project/addZqsxAuthProject', method: 'post', data: qs.stringify(data) })
}

// 编辑项目
export function updateZqsxAuthProject (data) {
  return request({ url: '/zqsx-auth-project/updateZqsxAuthProject', method: 'post', data: qs.stringify(data) })
}

// 删除项目
export function deleteZqsxAuthProject (data) {
  return request({ url: '/zqsx-auth-project/deleteZqsxAuthProject', method: 'post', data: qs.stringify(data) })
}

// 复制项目（传入源 zapId，生成带"副本"后缀的新项目，含模块树，自动把当前用户加为新项目管理员）
export function copyZqsxAuthProject (data) {
  return request({ url: '/zqsx-auth-project/copyZqsxAuthProject', method: 'post', data: qs.stringify(data) })
}

// ==================== 模块管理（内容管理：8大菜单及分级窗口配置） ====================

// 模块列表（分页，按父级 zmParentId 查询子级；项目管理员仅查所属项目）
export function getZqsxModelList (data) {
  return request({ url: '/zqsx-model/getZqsxModelList', method: 'post', data: qs.stringify(data) })
}

// 新增模块（根据 zmLayoutSelf 1列表/2网格/3内容 校验不同字段）
export function addZqsxModel (data) {
  return request({ url: '/zqsx-model/addZqsxModel', method: 'post', data: qs.stringify(data) })
}

// 编辑模块
export function updateZqsxModel (data) {
  return request({ url: '/zqsx-model/updateZqsxModel', method: 'post', data: qs.stringify(data) })
}

// 删除模块（递归软删自身及所有子模块）
export function deleteZqsxModel (data) {
  return request({ url: '/zqsx-model/deleteZqsxModel', method: 'post', data: qs.stringify(data) })
}

// 导出模块导入模板（返回 Excel 文件流，用于填写后批量导入证书）
export function exportZqsxModelTemplate () {
  return request({
    url: '/zqsx-model/exportZqsxModelTemplate',
    method: 'post',
    responseType: 'blob'
  })
}

// 批量导入证书（file 走 formData，zmParentId 走 URL query 参数）
// 返回：{ total, successCount, failCount, list }
export function importZqsxModelCer (data) {
  const { file, zmParentId } = data
  const formData = new FormData()
  formData.append('file', file)
  // zmParentId 为后端 @RequestParam，拼接为 URL query 参数；为空则不传（导入为一级模块）
  const params = {}
  if (zmParentId !== undefined && zmParentId !== null && zmParentId !== '') {
    params.zmParentId = zmParentId
  }
  return request({
    url: '/zqsx-model/importZqsxModelCer',
    method: 'post',
    data: formData,
    params
  })
}

// ==================== 文件上传 ====================

// 上传文件到腾讯云对象存储（FormData，字段名 file；返回 data 为文件可访问 URL）
// ⚠️ 注意：此接口走业务服务器中转，受 Nginx/CDN body 大小限制（22MB 可过、140MB+ 报 413）
// 仅适用于小文件，大文件请改用 getUploadPolicy + 前端直传 COS 方式
export function uploadFile (data) {
  return request({ url: '/tx-cloud-file/uploadFileToTxCloudEquityAjTools', method: 'post', data, timeout: 0 })
}

// 获取腾讯云 COS 临时密钥（STS）+ 存储桶/路径信息
// 返回 data：{ bucket, region, tmpSecretId, tmpSecretKey, sessionToken, startTime, expiredTime, baseHttp, filePath }
// 前端拿到后直接通过 cos-js-sdk-v5 直传 COS，绕开业务服务器 body 限制（支持 1GB+ 大文件）
export function getUploadPolicy (data) {
  return request({ url: '/tx-cloud-file/getPolicyTxCloudEquityAjTools', method: 'post', data: qs.stringify(data || {}) })
}

// ==================== 文件上传任务（管理端，岗位1/2） ====================

// 文件上传任务列表（分页，按 zfName 模糊查询）
export function getZqsxFileList (data) {
  return request({ url: '/zqsx-file/getZqsxFileList', method: 'post', data: qs.stringify(data) })
}

// 新增文件上传任务（zfName 任务名，后端校验唯一）
export function addZqsxFile (data) {
  return request({ url: '/zqsx-file/addZqsxFile', method: 'post', data: qs.stringify(data) })
}

// 编辑文件上传任务（zfId, zfName）
export function updateZqsxFile (data) {
  return request({ url: '/zqsx-file/updateZqsxFile', method: 'post', data: qs.stringify(data) })
}

// 删除文件上传任务（逻辑删除）
export function deleteZqsxFile (data) {
  return request({ url: '/zqsx-file/deleteZqsxFile', method: 'post', data: qs.stringify(data) })
}

// ==================== 用户上传记录（管理端查看，岗位1/2） ====================

// 用户上传记录列表（按 zfId/createuserid/projectId 筛选，分页）
export function getZqsxFileUserList (data) {
  return request({ url: '/zqsx-file-user/getZqsxFileUserList', method: 'post', data: qs.stringify(data) })
}

// 用户上传记录详情（zfuId，含 zfuFile JSON 字符串）
export function getZqsxFileUserById (data) {
  return request({ url: '/zqsx-file-user/getZqsxFileUserById', method: 'post', data: qs.stringify(data) })
}
